import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';

import Tooltip from '../../components/common/Tooltip';
import ErrorModal from '../../containers/common/ErrorModal';
import StyledTappable from '../common/StyledTappable';
import { RegularText, BoldText } from '../common/Text';
import {
  intitiateEmergencyCall,
  payLabCopay,
  postSamplePickup,
} from '../../services';
import initializeFreshDesk from '../../utils/freshchat';
import { logEvent } from '../../utils/logEvent';
import CardImage from '../../images/pharmacy/card';
import { openFileViewer } from '../../actions';
import arrowRight from '../../images/common/arrow-right.svg';
import ellipseIcon from '../../images/common/ellipse.svg';
import tickIcon from '../../images/common/tick.svg';
import cautionIcon from '../../images/common/caution.svg';
import clockIcon from '../../images/lab-test/green-clock.svg';
import PathologyIcon from '../../images/lab-test/pathology.svg';
import PathologyGreenIcon from '../../images/lab-test/microscope-green.svg';
import RadiologyIcon from '../../images/lab-test/radiology.svg';
import cartIcon from '../../images/lab-test/cart-new.svg';
import crossIcon from '../../images/lab-test/cross.svg';
import orderPlacedIcon from '../../images/lab-test/order-placed.svg';
import patientIcon from '../../images/lab-test/patient-icon.svg';
import calendarIcon from '../../images/lab-test/order-calendar.svg';
import partnerIcon from '../../images/lab-test/partner.svg';
import partnerNameIcon from '../../images/lab-test/partner-name.svg';
import completedIcon from '../../images/lab-test/completed.svg';
import completedEarlyIcon from '../../images/lab-test/completed-early.svg';
import partnerConfirmIcon from '../../images/lab-test/partner-icon.svg';
import sampleProcessingIcon from '../../images/lab-test/sample-processing.svg';
import prescriptionIcon from '../../images/lab-test/precription-card-icon.svg';
import samplePickUpIcon from '../../images/lab-test/sample-pickup.svg';
import profileIcon from '../../images/common/profile.svg';
import stethoscope from '../../images/pharmacy/stethoscope.png';
import arrowRightFill from '../../images/lab-test/arrowright-fill.svg';
import crossFillIcon from '../../images/lab-test/cross-fill.svg';
import newCrossIcon from '../../images/lab-test/new-cross.svg';
import SyringeIcon from '../../images/lab-test/syringe.svg';
import oldTimeIcon from '../../images/lab-test/old-time.svg';
import newTimeIcon from '../../images/lab-test/new-time.svg';
import oldPartnerIcon from '../../images/lab-test/old-partner.svg';
import copayIcon from '../../images/lab-test/copay.svg';
import copayWalletIcon from '../../images/lab-test/copay-wallet.svg';
import modalIcon from '../../images/lab-test/emergency-tick.svg';
import CIIcon from '../../images/pharmacy/ci-icon.svg';
//import ConfirmedIcon from '../../images/pharmacy/confirmed-icon.svg';
import ConfirmedIcon from '../../images/pharmacy/new-confirmed-icon.svg';
import CoPayIcon from '../../images/pharmacy/co-pay-icon.svg';
import DrugIcon from '../../images/pharmacy/drug-icon.svg';
import DeliveredIcon from '../../images/pharmacy/delivered-icon.svg';
import DateIcon from '../../images/pharmacy/date-icon.svg';
import OrderDeliveredIcon from '../../images/pharmacy/order-delivered-icon.svg';
import { ReactComponent as HomeDeliveryIcon } from '../../images/pharmacy/home-delivery-icon.svg';
import { ReactComponent as StorePickupIcon } from '../../images/pharmacy/store-pickup-icon.svg';
import AddressIcon from '../../images/pharmacy/address-icon.svg';
import DeliverDate from '../../images/pharmacy/delivery-date-icon.svg';
import DirectionIcon from '../../images/pharmacy/direction-icon.svg';
import TimeIcon from '../../images/pharmacy/time-icon.svg';
import hashtagIcon from '../../images/pharmacy/hashtag.svg';
import CancelledIcon from '../../images/pharmacy/cancelled-icon.svg';

const ScreenIcon = styled.img`
  filter: ${(props) =>
    props.type === 'digitisationDelayed' ||
    props.type === 'digitisationRejected' ||
    props.type === 'delayed'
      ? 'brightness(0) saturate(100%) invert(54%) sepia(42%) saturate(985%) hue-rotate(324deg) brightness(102%) contrast(100%)'
      : 'none'};
`;
const EllipseIcon = styled.img`
  filter: ${(props) =>
    props.type === 'digitisationDelayed' ||
    props.type === 'digitisationRejected' ||
    props.type === 'Delayed'
      ? 'brightness(0) saturate(100%) invert(54%) sepia(42%) saturate(985%) hue-rotate(324deg) brightness(102%) contrast(100%)'
      : 'none'};
`;

const IconContainer = styled.div`
  align-self: start;
  border: 1px solid
    ${(props) =>
      props.type === 'digitisationRejected' || props.orderStatus
        ? '#FF754C'
        : '#E3E3E3'};
  border-radius: 12px;
  margin-right: 12px;
  text-align: center;
  height: 40px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  height: 100svh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  max-width: 400px;
  padding: 1.125rem 1.25rem 1.875rem 1.25rem;
  border-radius: 0.5rem;
  margin: 0 1rem;
  text-align: center;
  z-index: 3;
`;
const CloseContainer = styled.div`
  cursor: pointer;
  align-self: flex-end;
`;

const ModalIcon = styled.img`
  width: 78px;
  height: 78px;
`;

const ModalText = styled(RegularText)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin: 0.625rem 0rem;
  color: #0f0b28;
  font-weight: 500;
`;

const providerLogoContainerStyles = {
  display: 'flex',
  // alignItems: 'center',
  // width: 'max-content',
  justifyContent: 'flex-end',
  gap: '5px',
  alignItems: 'center',
  // position:'relative'
};

const providerLogoStyles = {
  width: '38px',
  height: '38px',
  borderRadius: '50%',
  border: '2px solid rgb(228 228 228 / 66%)',
  position: 'relative',
};

const PatientName = ({ patientName }) => (
  <div className="flex items-start mt-8px">
    <img src={patientIcon} alt="patient-icon"></img>
    <div className="flex text-body-s ml-8px font-medium gap-8px">
      <p className="text-sub">Patient:</p>
      <p className="text-txtlight">{patientName}</p>
    </div>
  </div>
);

const DateTimeSlot = ({ slotDateTime }) => (
  <div className="flex flex-row items-center mt-8px">
    <img src={calendarIcon} alt="calendar-icon" className="self-start" />
    <div className="flex text-body-s ml-8px font-medium gap-8px ">
      <p className="text-sub">Date & Time Slot:</p>
      <p className="text-txtlight">{slotDateTime}</p>
    </div>
  </div>
);

const PartnerName = ({ partnerName }) => (
  <div className="flex flex-row items-center mt-8px">
    <img src={partnerIcon} alt="building-icon" className="self-start" />
    <div className="flex text-body-s ml-8px font-medium gap-8px ">
      <p className="text-sub">Partner</p>
      <p className="text-txtlight">{partnerName}</p>
    </div>
  </div>
);

const OrderIDAndBookedOn = ({ orderId, bookedOnDate }) => (
  <div className="flex flex-row">
    <img src={clockIcon} alt="prescribed-time" className="self-start" />
    <div className="flex flex-col">
      <p className="text-body-s text-txtlight font-medium ml-8px w-full">
        Order ID - {orderId}
      </p>
      <p className="text-chip text-sub ml-8px">Booked on {bookedOnDate}</p>
    </div>
  </div>
);

const CardHeader = ({
  type,
  orderStatus,
  icon,
  title,
  text,
  reason,
  noBorderBottom,
}) => (
  <div
    className={`flex flex-row justify-between items-center px-16px pb-12px ${
      noBorderBottom ? '' : 'border-b border-txtlight-shades4'
    }`}
  >
    <div className="flex w-full">
      <IconContainer color={type} orderStatus={orderStatus}>
        <img src={icon} alt="card-title-icon" className="w-24px h-24px" />
      </IconContainer>
      <div className="flex flex-col w-full">
        <div className="flex w-full justify-between">
          <span className="text-title-s font-semibold text-txtlight">
            {title}
          </span>
          <ScreenIcon
            src={arrowRight}
            alt="right"
            type={type}
            className="w-6px"
          />
        </div>
        {!!text && (
          <div className="text-chip font-medium mt-2px text-sub">{text}</div>
        )}
        {!!reason && (
          <div className="text-chip font-semibold mt-2px text-sub">
            {reason}
          </div>
        )}
      </div>
    </div>
  </div>
);
const PrescriptionStatusCard = ({ orderRequest, onTap, history, key }) => {
  let {
    cardType: type,
    digitisationId,
    prescribedTime,
    status,
    orderStatus,
  } = orderRequest;
  const authToken = useSelector((state) => state.user.authToken);
  const user = useSelector((state) => state.user);
  const [modalDetails, setModalDetails] = useState({
    showModal: false,
    modalText: '',
  });
  const [showTooltip, setShowTooltip] = useState(false);
  const [ciToolTip, setCiToolTip] = useState(false);
  const dispatch = useDispatch();
  const emergencyCallHandler = (e) => {
    e.stopPropagation();

    if (!orderRequest.orderId && orderRequest.isDelayed) {
      initializeFreshDesk(user);
    } else {
      const orderId = orderRequest.orderId;
      intitiateEmergencyCall(authToken, orderId)
        .then((res) => {
          console.log(res);
          setModalDetails({ showModal: true, modalText: res });
        })
        .catch((err) => {});
    }
  };
  const hideModal = (e) => {
    e.stopPropagation();
    setModalDetails({ showModal: false, modalText: '' });
  };
  const openSupport = (e) => {
    e.stopPropagation();
    window.open(
      `${user.ticketingUrl}?token=${user.authToken.split(' ')[1]}`,
      '_blank'
    );
  };

  if (orderRequest.orderStatus === 'confirmed' && orderRequest.amount) {
    type = 'order';
    orderRequest.orderStatus = 'mix-credit';
  }

  if (
    type === 'digitisationDelayed' ||
    type === 'transcribing' ||
    type === 'digitisationRejected'
  ) {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid ${status !== 'Delayed' ? '#E6E9EC' : '#FF754C'}`,
        }}
        onClick={onTap}
      >
        {/* <div className="flex flex-row justify-between items-center px-16px pb-10px border-b border-txtlight-shades4">
          <div className="flex justify-between w-full items-start">
            <div className="flex">
              <IconContainer
                color={type}
                orderStatus={status === 'Rejected' || status === 'Delayed'}
              >
                <img
                  src={prescriptionIcon}
                  alt="prescription"
                  style={{
                    minWidth: '17.37px',
                    minHeight: '26.12px',
                    margin: '12px',
                  }}
                />
              </IconContainer>
              <div className="flex flex-col">
                <span className="text-title-s font-semibold text-txtlight">
                  {orderRequest.title}
                </span>
                <div
                  className="text-chip font-medium mt-2px"
                  style={{
                    color: `${status === 'Rejected' ? '#0F0B28' : '#767787'}`,
                  }}
                >
                  <p className="text-sub font-medium">{orderRequest.text}</p>
                  {status === 'Rejected' && orderRequest.invalid_reason && (
                    <p className="text-sub  font-bold">
                      Reason: {orderRequest.invalid_reason}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <img className="float-right" src={arrowRight} alt="right" />
          </div>
        </div> */}
        <CardHeader
          type={type}
          orderStatus={status === 'Rejected' || status === 'Delayed'}
          icon={prescriptionIcon}
          title={orderRequest.title}
          text={`${orderRequest.text}`}
          reason={
            orderRequest.invalid_reason
              ? `Reason: ${orderRequest.invalid_reason}`
              : null
          }
          noBorderBottom
        />
        <div className="flex flex-row items-end justify-between py-12px px-16px border-t border-txtlight-shades4 ">
          {orderRequest.status !== 'Uploaded' && (
            <div className="flex items-start">
              <img src={hashtagIcon} alt="prescribed-time" />
              <div className="flex flex-col  ml-8px">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Request Id: {orderRequest.digitisationId}
                </p>
              </div>
            </div>
          )}
          {orderRequest.status === 'Uploaded' && (
            <div className="flex items-start">
              <img src={hashtagIcon} alt="prescribed-time" />
              <div className="flex flex-col  ml-8px">
                <p className="text-body-s">
                  Digitization Id: {orderRequest.digitisationId}
                </p>
                <p className="text-sub text-card-body">
                  Requested On: {orderRequest.prescribedTime}
                </p>
              </div>
            </div>
          )}
          <div className="flex flex-row items-center">
            {status === 'Rejected' ? (
              <img src={crossIcon} alt="cross" />
            ) : (
              <div>
                <EllipseIcon
                  src={ellipseIcon}
                  alt="ellipse"
                  height={11}
                  width={12}
                  className="icon-spin"
                  type={status}
                />
              </div>
            )}

            <span
              className="text-body-s font-medium ml-4px"
              style={{
                color: `${status !== 'Uploaded' ? '#FF754C' : '#3F8CFF'}`,
              }}
            >
              {status === 'Uploaded' && 'Digitizing'}
              {status === 'Delayed' && 'Delayed'}
              {status === 'Rejected' && 'Query Raised'}
            </span>
          </div>
        </div>
        {status === 'Delayed' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-primary font-semibold tracking-wide border-t border-txtlight-shades4"
            onClick={openSupport}
          >
            Contact Support
          </button>
        )}

        {status === 'Rejected' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-primary font-semibold tracking-wide border-t border-txtlight-shades4"
            onClick={(e) => {
              e.stopPropagation();
              logEvent('Pharmacy Re-upload Prescription');
              history.push('/pharmacy/query-history', {
                digitisationId: orderRequest?.digitisationId,
              });
            }}
          >
            View Query
          </button>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'transcribed') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid ${'#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        {/* <div className="flex flex-row justify-between items-center px-16px pb-16px border-b border-txtlight-shades4">
          <div className="flex">
            <IconContainer color={type}>
              <img
                src={orderPlacedIcon}
                alt="order-placed"
                style={{ minWidth: '19.71px', minHeight: '19.71px' }}
              />
            </IconContainer>
            <div className="flex flex-col justify-center">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip text-sub font-medium mt-2px ">
                {orderRequest.text}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={type}
          />
        </div> */}
        <CardHeader
          type={type}
          status={status}
          icon={orderPlacedIcon}
          title={orderRequest.title}
          text={orderRequest.text}
        />
        {orderRequest.patientName && (
          <div className="flex flex-row items-end justify-between pb-12px px-16px mt-12px border-b border-txtlight-shades4">
            <PatientName patientName={orderRequest.patientName} />
          </div>
        )}
        {orderRequest.showEmergencyButtonCall && (
          <div
            className="text-center py-12px text-body-s text-primary font-semibold tracking-wide"
            onClick={openSupport}
          >
            {type === 'digitisationDelayed'
              ? 'Contact Support'
              : 'Request Callback'}
          </div>
        )}
        {orderRequest.resubmit && (
          <button
            className="text-center py-12px text-body-s text-primary font-semibold"
            onClick={() => {
              logEvent('Pharmacy Re-upload Prescription');
              history.push('/pharmacy/upload-prescription');
            }}
          >
            Re-upload Prescription
          </button>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'reimbursement') {
    return (
      <div
        className="hover p-16px pb-12px mt-16px border border-txtsecondary-shades7 border-solid rounded-12 clickable"
        onClick={onTap}
      >
        <div className="flex flex-row justify-between	items-center pb-4px">
          <span className="text-title-s font-semibold">Reimbursement</span>
          <img className="float-right" src={arrowRight} alt="right" />
        </div>
        <div>
          <PatientName patientName={orderRequest.patientName} />
          <p className="txt-grey-600-12 mt-4 mb-4">
            {orderRequest.prescriptionGivenOn}
          </p>

          <p className="txt-black-600-12 lab-home-btn hover" onClick={onTap}>
            {orderRequest.btnLabel}
          </p>
        </div>
      </div>
    );
  } else if (type === 'booked-order') {
    return (
      <div
        className="p-16px pt-0 pb-12px mt-16px border border-txtsecondary-shades7 border-solid	rounded-12 clickable"
        onClick={() => {
          onTap(orderRequest);
        }}
      >
        <span
          className="py-4px px-12px text-secondary-shades2 text-body-s font-semibold"
          style={{
            background: 'rgba(207, 200, 255, 0.2)',
            borderRadius: '0px 0px 8px 8px',
          }}
        >
          {orderRequest.testsTypeName}
        </span>
        <div className="flex flex-row justify-between pt-12px items-center pb-4px">
          <div className="flex flex-row items-center">
            {orderRequest.status === 'pending' ||
            orderRequest.status === 'completed' ? (
              <img src={tickIcon} alt="tick" height={11} width={12} />
            ) : (
              <img src={cautionIcon} alt="tick" height={11} width={12} />
            )}
            <div
              className="text-body-s font-semibold pl-8px"
              style={
                orderRequest.status === 'pending' ||
                orderRequest.status === 'completed'
                  ? { color: '#3F8CFF' }
                  : { color: '#FF754C' }
              }
            >
              {orderRequest.status === 'payment-pending'
                ? orderRequest.pendingCopayText || orderRequest.status
                : orderRequest.status}
            </div>
          </div>
        </div>
        <div className="text-title-s font-semibold">
          {orderRequest.testNames}
        </div>
        {orderRequest.doctorName && (
          <div className="flex flex-row items-center pb-2px">
            <img
              src={stethoscope}
              alt="stethoscope"
              className="h-12px w-12px"
            />
            <div className="text-body-s text-txtsecondary font-medium pl-4px ">
              {orderRequest.doctorName}
            </div>
          </div>
        )}

        {orderRequest.patientName && (
          <PatientName patientName={orderRequest.patientName} />
        )}
        <div className="flex flex-row justify-between items-center">
          <div className="text-chip text-txtsecondary">
            {orderRequest.bookedOn}
          </div>
          <div className="flex flex-row hover">
            <p className="text-body-l text-primary font-semibold mr-8px">
              {orderRequest.status === 'payment-pending'
                ? 'Pay & Confirm'
                : 'View Details'}
            </p>
            <img src={arrowRightFill} alt="" />
          </div>
        </div>
      </div>
    );
  } else if (type === 'availableCart') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 border border-solid border-boxCard clickable"
        onClick={onTap}
      >
        {/* <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '10px 9px' }}>
              <img
                src={cartIcon}
                alt="cart"
                style={{ minWidth: '23px', minHeight: '19px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <img
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={type}
          />
        </div> */}
        <CardHeader
          title={orderRequest.title}
          icon={cartIcon}
          text={orderRequest.infoText}
          type={type}
        />
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <div className="flex flex-row">
            {!orderRequest.digitisationId ? (
              <>
                <img
                  src={stethoscope}
                  alt="prescribed-time"
                  width={'16px'}
                  height={'16px'}
                />
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  {orderRequest.consultationStr}
                </p>
              </>
            ) : (
              <>
                <img src={hashtagIcon} alt="prescribed-time" />
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Request ID - {orderRequest.digitisationId}
                </p>
              </>
            )}
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img src={RadiologyIcon} alt="test type" className="self-start" />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
        </div>
        <div
          className="text-center py-12px text-body-s text-primary font-semibold tracking-wide"
          onClick={() => {
            history.push('/pharmacy/order-status', {
              cartId: orderRequest.cartId,
              digitizationId: orderRequest.digitizationId,
              bookedOnDate: orderRequest.bookedOnDate ?? null,
            });
          }}
        >
          Place Order
        </div>
      </div>
    );
  } else if (type === 'order') {
    const mainIcon = () => {
      if (orderRequest.orderStatus === 'confirmed') return ConfirmedIcon;
      else if (orderRequest.orderStatus === 'select-partner')
        return ConfirmedIcon;
      else if (orderRequest.orderStatus === 'cart-created')
        return partnerConfirmIcon;
      else if (orderRequest.orderStatus === 'partner-confirmation-delayed')
        return partnerConfirmIcon;
      else if (orderRequest.orderStatus === 'mix-credit') return CoPayIcon;
      else if (orderRequest.orderStatus === 'cancelled') return newCrossIcon;
      else if (orderRequest.orderStatus === 'delivered')
        return OrderDeliveredIcon;
      else return orderPlacedIcon;
    };
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 border border-solid border-boxCard clickable"
        onClick={onTap}
        style={{
          borderColor:
            orderRequest?.status?.toLowerCase() === 'delayed' ||
            orderRequest?.orderStatus?.toLowerCase() === 'cancelled'
              ? '#FF754C'
              : '',
        }}
      >
        {orderRequest.orderDeliveryType &&
          orderRequest.orderStatus !== 'cancelled' &&
          orderRequest.orderStatus === 'confirmed' && (
            <div className="px-20px  w-full flex">
              <div className="flex p-12px bg-primary-light w-auto items-center py-6px rounded-b-12">
                {orderRequest.orderDeliveryType === 'home-delivery' ? (
                  <HomeDeliveryIcon fill="var(--primary-button)"></HomeDeliveryIcon>
                ) : (
                  <StorePickupIcon fill="var(--primary-button)"></StorePickupIcon>
                )}

                <p className="ml-8px text-primary text-body-s font-semibold">
                  {orderRequest.orderDeliveryType === 'home-delivery'
                    ? 'Home Delivery'
                    : 'Store Pickup'}
                </p>
              </div>
            </div>
          )}
        {/* <div className="flex flex-row justify-between items-center px-16px pb-20px pt-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer
              color={type}
              orderStatus={
                orderRequest?.orderStatus?.toLowerCase() === 'cancelled' ||
                orderRequest?.status?.toLowerCase() === 'rejected' ||
                orderRequest?.status?.toLowerCase() === 'delayed'
              }
            >
             <img src= {mainIcon()} />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.headingText}
              </span>
              {orderRequest?.cancelReason ? (
                <div className="mt-2px text-chip text-sub font-medium">
                  Reason: {orderRequest?.cancelReason}
                </div>
              ) : (
                <div className="text-chip text-sub font-medium mt-2px">
                  {orderRequest?.text}
                </div>
              )}
            </div>
          </div>
          <img
            className="float-right self-start mt-2"
            src={arrowRight}
            alt="right"
          />
        </div> */}
        <CardHeader
          title={orderRequest.headingText}
          orderStatus={
            orderRequest?.orderStatus?.toLowerCase() === 'cancelled' ||
            orderRequest?.status?.toLowerCase() === 'rejected' ||
            orderRequest?.status?.toLowerCase() === 'delayed'
          }
          type={type}
          icon={mainIcon()}
          text={orderRequest.text}
          reason={
            orderRequest.cancelReason
              ? `Reason: ${orderRequest.cancelReason}`
              : null
          }
        />
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          {orderRequest.orderId && (
            <div className="flex items-center ">
              <img src={hashtagIcon} alt="" />
              <p className="ml-8px text-body-s font-medium">
                <span className="text-sub">Order ID: </span>
                {orderRequest?.orderId}
              </p>
            </div>
            // <div className="flex items-start">
            //   <img src={hashtagIcon} alt="prescribed-time" />
            //   <div className="flex flex-col ml-8px">
            //     <p className="text-body-s text-txtlight font-medium  w-full">
            //       Order ID - {orderRequest.orderId}
            //     </p>
            //     {/* {orderRequest.createdAt && (
            //       <p className="text-card-body text-sub">
            //         Booked on - {orderRequest.createdAt}
            //       </p>
            //     )} */}
            //   </div>
            // </div>
          )}

          {orderRequest.patientName && (
            <PatientName patientName={orderRequest.patientName} />
          )}

          {orderRequest.createdAt && (
            <div className="flex items-center mt-10px">
              <img src={TimeIcon} alt="" />
              <p className="ml-8px text-body-s font-medium">
                <span className="text-sub">Delivered On: </span>
                {orderRequest.createdAt}
              </p>
            </div>
          )}
          <div className="flex justify-between items-center w-full">
            {orderRequest.address &&
              orderRequest.orderStatus !== 'cancelled' && (
                <div className="flex items-center mt-10px">
                  <img src={AddressIcon} alt="" />
                  <p className="ml-8px text-body-s font-medium">
                    <span className="text-sub">
                      {' '}
                      {orderRequest.orderDeliveryType === 'home-delivery'
                        ? 'Delivery Address:'
                        : 'Pickup Address:'}{' '}
                    </span>
                    {orderRequest.address.length > 28
                      ? orderRequest.address.substr(0, 28) + '...'
                      : orderRequest.address}
                  </p>
                </div>
              )}

            {(orderRequest.orderStatus === 'placed' ||
              orderRequest.orderStatus === 'partner-confirmation-delayed') &&
              orderRequest.orderDeliveryType !== 'home-delivery' &&
              orderRequest.storeLat &&
              orderRequest.storeLong && (
                <button
                  className="w-6 h-6 flex justify-center items-center rounded-8"
                  style={{
                    background: ' rgba(28, 143, 248, 0.1)',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(
                      `https://maps.google.com/?q=${orderRequest.storeLat},${orderRequest.storeLong}`,
                      '_blank'
                    );
                  }}
                >
                  <img src={DirectionIcon} alt=""></img>
                </button>
              )}
          </div>
          {orderRequest.deliveryDate && (
            <div className="flex items-center mt-10px">
              <img src={DeliverDate} alt="" />
              <p className="ml-8px text-body-s font-medium">
                <span className="text-sub">Estimated Delivery Date: </span>
                {orderRequest.deliveryDate}
              </p>
            </div>
          )}
          {/* <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div> */}
          {orderRequest.orderStatus !== 'select-partner' &&
            orderRequest.partnerName && (
              <div className="flex flex-row items-center justify-between font-bold text-body-m mt-8px w-full">
                <div className="flex items-center ">
                  <img src={partnerIcon} alt="" />
                  <p className="ml-8px text-body-s font-medium">
                    <span className="text-sub">Partner: </span>
                    {orderRequest.partnerName}
                  </p>
                </div>
                {orderRequest.orderStatus === 'delivered' && (
                  <div className="flex items-center">
                    <img src={DeliveredIcon} alt=""></img>
                    <span
                      className="text-body-s text-green-shades5 font-medium ml-4px"
                      style={{
                        color: '#7DCC18',
                      }}
                    >
                      Completed
                    </span>
                  </div>
                )}
                {orderRequest.orderStatus === 'cancelled' && (
                  <div className="flex items-center">
                    <img src={CancelledIcon} alt=""></img>
                    <span
                      className="text-body-s text-green-shades5 font-medium ml-4px"
                      style={{
                        color: '#ff754c',
                      }}
                    >
                      Cancelled
                    </span>
                  </div>
                )}
                {orderRequest.orderStatus === 'placed' &&
                  (orderRequest.orderDeliveryType === 'home-delivery' ||
                    orderRequest.orderDeliveryType === 'pick-up') && (
                    <div className="flex items-center">
                      <EllipseIcon
                        src={ellipseIcon}
                        alt="ellipse"
                        height={11}
                        width={12}
                        className="icon-spin"
                        type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
                      />
                      <span
                        className="text-body-s font-medium ml-4px"
                        style={{ color: '#3F8CFF' }}
                      >
                        Confirming
                      </span>
                    </div>
                  )}
                {orderRequest.orderStatus === 'partner-confirmation-delayed' &&
                  orderRequest.status === 'Delayed' && (
                    <div className="flex items-center">
                      <EllipseIcon
                        src={ellipseIcon}
                        alt="ellipse"
                        height={11}
                        width={12}
                        className="icon-spin"
                        type={'Delayed'}
                      />
                      <span
                        className="text-body-s font-medium ml-4px"
                        style={{ color: '#ff754c' }}
                      >
                        Delayed
                      </span>
                    </div>
                  )}

                {orderRequest.orderStatus === 'mix-credit' && (
                  <div className="flex items-center relative">
                    {showTooltip && (
                      <div
                        className="absolute text-body-s font-regular p-10px rounded-8 z-30"
                        style={{
                          width: '200px',
                          top: '-350%',
                          left: '-275%',
                          background: '#F4F0FF',
                        }}
                      >
                        {orderRequest.toolTip}
                      </div>
                    )}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        showTooltip
                          ? setShowTooltip(false)
                          : setShowTooltip(true);
                      }}
                      className="py-1px px-8px rounded-4 text-body-s"
                      style={{ background: '#F4F0FF' }}
                    >
                      i
                    </button>
                    <p className="ml-12px">₹ {orderRequest.amount}</p>
                  </div>
                )}
              </div>
            )}

          <div
            className="flex flex-row justify-between"
            style={{ width: '100%' }}
          >
            {orderRequest.prescribedTime && (
              <div className="flex flex-row items-start mt-8px">
                <img src={DateIcon} alt=""></img>
                <div className="flex flex-col">
                  <p className="text-body-s text-txtlight font-medium ml-8px">
                    Date & Time
                  </p>
                  <p className="text-chip text-txtsecondary-shades8 ml-8px">
                    {orderRequest.prescribedTime}
                  </p>
                </div>
              </div>
            )}

            {/* <div style={providerLogoContainerStyles}>
              {orderRequest.partnersLogo &&
                orderRequest.partnersLogo
                  .filter((logo) => logo)
                  .map((item, index, array) => {
                    return item ? (
                      <div key={index}>
                        <img
                          src={item}
                          style={{
                            ...providerLogoStyles,
                            zIndex: 1,
                            right: `${(array.length - 1 - index) * -20}px`,
                          }}
                          alt=""
                        />
                      </div>
                    ) : (
                      <div />
                    );
                  })}
            </div> */}
          </div>
        </div>
        {orderRequest.status === 'Delayed' && (
          <button
            className="flex justify-center w-11/12 mx-auto mt-10px mb-10px text-center py-12px text-body-s rounded-lg  text-primary-light bg-primary font-semibold tracking-wide"
            onClick={openSupport}
          >
            Contact Support
          </button>
        )}
        {orderStatus === 'cart-created' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-primary font-semibold tracking-wide"
            onClick={(e) => {
              e.stopPropagation();
              history.push('/pharmacy/order-review', {
                cartId: orderRequest.cartId,
              });
            }}
          >
            Place Order
          </button>
        )}
        {orderStatus === 'select-partner' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-primary font-semibold tracking-wide"
            onClick={(e) => {
              e.stopPropagation();
              history.push('/pharmacy/select-partner', {
                cartId: orderRequest.cartId,
                digitisationId: orderRequest.digitisationId,
                isReOrderCart: orderRequest.isReOrderCart,
              });
            }}
          >
            Place order
          </button>
        )}
      </div>
    );
  } else if (type === 'samplePickUp') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '12px 10.50px' }}>
              <img
                src={samplePickUpIcon}
                alt="sample-pickup"
                style={{ minWidth: '19.76px', minHeight: '16.85px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <OrderIDAndBookedOn
            orderId={orderRequest.orderId}
            bookedOn={orderRequest.bookedOnDate}
          />
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>

          <PatientName patientName={orderRequest.patientName} />
          <DateTimeSlot slotDateTime={orderRequest.slotDateTime} />
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <PartnerName partnerName={orderRequest.partnerName} />
            <div className="flex flex-row items-center">
              <EllipseIcon
                src={ellipseIcon}
                alt="ellipse"
                height={11}
                width={12}
                className="icon-spin"
                type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
              />
              <span
                className="text-body-s font-medium ml-4px"
                style={{
                  color: `${!orderRequest.isDelayed ? '#3F8CFF' : '#FF754C'}`,
                }}
              >
                {orderRequest.isDelayed ? 'Delayed' : 'Confirming'}
              </span>
            </div>
          </div>
        </div>
        {orderRequest.showEmergencyButtonCall && (
          <div
            className="text-center text-body-s text-primary font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
            onClick={emergencyCallHandler}
          >
            {orderRequest.isDelayed &&
              !orderRequest.orderId &&
              'Contact Support'}
            {orderRequest.orderId && 'Request Callback'}
          </div>
        )}
        {orderRequest.questionToAsk && (
          <div>
            <div className="text-center text-body-s text-txtlight font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide">
              {orderRequest.questionToAsk}
            </div>
            <div className="text-center text-body-s font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide flex flex-row items-center">
              <div
                className="text-primary flex-1"
                onClick={(e) => {
                  e.stopPropagation();
                  postSamplePickup(authToken, true, orderRequest.orderId);
                }}
              >
                Yes, on time!
              </div>
              <div
                style={{ minHeight: '18px', border: '1px solid #F0F3F6' }}
              ></div>
              <div
                className="flex-1"
                style={{ color: '#F25540' }}
                onClick={(e) => {
                  e.stopPropagation();
                  postSamplePickup(authToken, false);
                }}
              >
                No, not yet!
              </div>
            </div>
          </div>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'partnerConfirmation' || type === 'partnerConfirmed') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '12px 9px' }}>
              <img
                src={partnerConfirmIcon}
                alt="sample-pickup"
                style={{ minWidth: '23.1px', minHeight: '15.23px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <OrderIDAndBookedOn
            orderId={orderRequest.orderId}
            bookedOn={orderRequest.bookedOnDate}
          />
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>

          <PatientName patientName={orderRequest.patientName} />
          <DateTimeSlot slotDateTime={orderRequest.slotDateTime} />
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <PartnerName partnerName={orderRequest.partnerName} />
            <div className="flex flex-row items-center">
              {orderRequest.isDelayed ? (
                <>
                  <EllipseIcon
                    src={ellipseIcon}
                    alt="ellipse"
                    height={11}
                    width={12}
                    className="icon-spin"
                    type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
                  />
                  <span
                    className="text-body-s font-medium ml-4px"
                    style={{
                      color: `${
                        !orderRequest.isDelayed ? '#3F8CFF' : '#FF754C'
                      }`,
                    }}
                  >
                    Delayed
                  </span>{' '}
                </>
              ) : (
                <>
                  <img src={partnerNameIcon} alt="lab" className="self-start" />
                  <p className="text-body-s font-medium text-primary ml-4px">
                    {orderRequest.partnerName}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        {orderRequest.showEmergencyButtonCall ? (
          <div
            className="text-center text-body-s text-primary font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
            onClick={emergencyCallHandler}
          >
            {orderRequest.isDelayed &&
              !orderRequest.orderId &&
              'Contact Support'}
            {orderRequest.orderId && 'Request Callback'}
          </div>
        ) : (
          <div></div>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'sampleProcessing') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '11px 12px' }}>
              <img
                src={sampleProcessingIcon}
                alt="sample-pickup"
                style={{ minWidth: '16.64px', minHeight: '17.05px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <OrderIDAndBookedOn
            orderId={orderRequest.orderId}
            bookedOn={orderRequest.bookedOnDate}
          />
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>

          <PatientName patientName={orderRequest.patientName} />
          <DateTimeSlot slotDateTime={orderRequest.slotDateTime} />

          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <PartnerName partnerName={orderRequest.partnerName} />
            <div className="flex flex-row items-center">
              <EllipseIcon
                src={ellipseIcon}
                alt="ellipse"
                height={11}
                width={12}
                className="icon-spin"
                type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
              />
              <span
                className="text-body-s font-medium ml-4px"
                style={{
                  color: `${!orderRequest.isDelayed ? '#3F8CFF' : '#FF754C'}`,
                }}
              >
                {orderRequest.isDelayed ? 'Delayed' : 'Reports Awaited'}
              </span>
            </div>
          </div>
        </div>
        {orderRequest.showEmergencyButtonCall ? (
          <div
            className="text-center text-body-s text-primary font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
            onClick={emergencyCallHandler}
          >
            {orderRequest.isDelayed &&
              !orderRequest.orderId &&
              'Contact Support'}
            {orderRequest.orderId && 'Request Callback'}
          </div>
        ) : (
          <div></div>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'reportGenerated') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid ${
            orderRequest.completedRemarks ? '#7DCC18' : '#E6E9EC'
          }`,
        }}
        onClick={(e) => {
          e.stopPropagation();
          onTap();
        }}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '11px 12px' }}>
              <img
                src={sampleProcessingIcon}
                alt="sample-pickup"
                style={{ minWidth: '16.64px', minHeight: '17.05px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <OrderIDAndBookedOn
            orderId={orderRequest.orderId}
            bookedOn={orderRequest.bookedOnDate}
          />
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <PatientName patientName={orderRequest.patientName} />{' '}
          <DateTimeSlot slotDateTime={orderRequest.slotDateTime} />
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <PartnerName partnerName={orderRequest.partnerName} />
            <div className="flex flex-row items-center">
              {orderRequest.completedRemarks ? (
                <>
                  <img src={completedEarlyIcon} alt="completed-icon" />
                  <span
                    className="text-body-s font-medium ml-4px"
                    style={{
                      color: `#7DCC18`,
                    }}
                  >
                    {orderRequest.completedRemarks}
                  </span>
                </>
              ) : (
                <>
                  <img src={completedIcon} alt="completed-icon" />
                  <span
                    className="text-body-s font-medium ml-4px"
                    style={{
                      color: `#7DCC18`,
                    }}
                  >
                    Complete
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              openFileViewer({
                contentUrl: orderRequest.reportUrl,
                type: 'pdf',
                title: 'Report',
              })
            );
          }}
          className="py-16px px-20px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
        >
          <p
            // href={`${orderRequest.reportUrl}`}
            className="bg-primary text-center py-12px rounded-12 text-body-s font-bold block"
            style={{ color: 'white' }}
          >
            Download Report
          </p>
        </button>
        <div className="py-16px px-20px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide text-center text-sub text-chip font-medium">
          {orderRequest.description}
        </div>
        <div
          className="py-16px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide text-center text-primary text-body-s font-semibold"
          onClick={(e) => {
            e.stopPropagation();
            history.push('/consultation/start');
          }}
        >
          Consult Doctor
        </div>
      </div>
    );
  } else if (type === 'partialReportGenerated') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: '1px solid #E6E9EC',
        }}
        onClick={(e) => {
          e.stopPropagation();
          onTap();
        }}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '11px 12px' }}>
              <img
                src={sampleProcessingIcon}
                alt="sample-pickup"
                style={{ minWidth: '16.64px', minHeight: '17.05px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <OrderIDAndBookedOn
            orderId={orderRequest.orderId}
            bookedOn={orderRequest.bookedOnDate}
          />
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <PatientName patientName={orderRequest.patientName} />{' '}
          <DateTimeSlot slotDateTime={orderRequest.slotDateTime} />
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <PartnerName partnerName={orderRequest.partnerName} />
            <div className="flex flex-row items-center">
              <EllipseIcon
                src={ellipseIcon}
                alt="ellipse"
                height={11}
                width={12}
                className="icon-spin"
                type={type}
              />
              <span
                className="text-body-s font-medium ml-4px"
                style={{
                  color: `#3F8CFF`,
                }}
              >
                Reports Awaited
              </span>
            </div>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            window.location.href = orderRequest.reportUrl;
          }}
          className="py-16px px-20px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
        >
          <p
            className="bg-primary text-center py-12px rounded-12 text-body-s font-bold block"
            style={{ color: 'white' }}
          >
            Download Report
          </p>
        </button>
      </div>
    );
  } else if (type === 'orderCancelled') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: '1px solid #E6E9EC',
        }}
        onClick={onTap}
      >
        {/* <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer
              color={type}
              style={{ border: '1px solid #FF754C', padding: '11px' }}
            >
              <img
                src={newCrossIcon}
                alt="cancelled"
                style={{ minWidth: '18px', minHeight: '18px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title
                  ? orderRequest.title
                  : orderRequest.testNames}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                Reason : {orderRequest.reason}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            style={{ filter: 'brightness(0) saturate(100%)' }}
          />
        </div> */}
        <CardHeader
          icon={newCrossIcon}
          title={
            orderRequest.title ? orderRequest.title : orderRequest.testNames
          }
          reason={
            orderRequest.cancelReason
              ? `Reason: ${orderRequest.cancelReason}`
              : null
          }
          type={type}
        />
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <div className="flex flex-row items-center justify-between w-full">
            <div className="flex flex-row">
              <img src={patientIcon} alt="patient" className="self-start" />
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                {orderRequest.patientName}
              </p>
            </div>
            <div className="flex flex-row items-center">
              {orderRequest.testsType === 'pathology' && (
                <img
                  src={PathologyGreenIcon}
                  alt="test type"
                  className="self-start"
                />
              )}
              {orderRequest.testsType === 'radiology' && (
                <img
                  src={RadiologyIcon}
                  alt="test type"
                  className="self-start"
                />
              )}
              {orderRequest.testsType === 'vaccination' && (
                <img src={SyringeIcon} alt="test type" className="self-start" />
              )}
              <p className="text-body-s text-txtlight ml-8px">
                {orderRequest.testsTypeName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center justify-between w-full mt-8px">
            <div className="flex flex-row">
              <ScreenIcon
                src={clockIcon}
                alt="patient"
                className="self-start"
                type="delayed"
              />
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                {orderRequest.cancelledOn}
              </p>
            </div>
            <div className="flex flex-row items-center">
              <img src={crossFillIcon} alt="cancelled" />
              <p className="text-body-s text-accent2-shades4 ml-4px font-semibold">
                Cancelled
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (type === 'copay') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        {/* <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer
              color={type}
              style={{ padding: '10px', paddingRight: '9.59px' }}
            >
              <img
                src={copayWalletIcon}
                alt="copay"
                style={{ minWidth: '20.81px', minHeight: '20.41px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div> */}
        <CardHeader
          title={orderRequest.title}
          icon={copayWalletIcon}
          text={orderRequest.infoText}
          type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
        />
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <OrderIDAndBookedOn
            orderId={orderRequest.orderId}
            bookedOn={orderRequest.bookedOnDate}
          />
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <PatientName patientName={orderRequest.patientName} />{' '}
          <DateTimeSlot slotDateTime={orderRequest.slotDateTime} />
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <PartnerName partnerName={orderRequest.partnerName} />
            <div className="flex flex-row items-center">
              <Tooltip content={orderRequest.pendingCopayText}>
                <img src={copayIcon} alt="copay" />
              </Tooltip>
              <p className="text-body-l text-txtlight font-bold ml-8px">
                ₹ {orderRequest.pendingCopayAmount}
              </p>
            </div>
          </div>
        </div>
        <div
          className="py-12px text-center text-body-l font-semibold text-primary"
          onClick={(e) => {
            e.stopPropagation();
            payLabCopay(orderRequest.orderId, history, authToken);
          }}
        >
          Make Payment
        </div>
      </div>
    );
  } else if (
    type === 'orderUpdate' ||
    type === 'orderUpdatePartner' ||
    type === 'orderUpdateReschedule'
  ) {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 clickable"
        style={{
          border: `1px solid #E6E9EC`,
        }}
        onClick={onTap}
      >
        {/* <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '12px 9px' }}>
              <img
                src={partnerConfirmIcon}
                alt="order-update"
                style={{ minWidth: '23.1px', minHeight: '15.23px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div> */}
        <CardHeader
          icon={partnerConfirmIcon}
          title={orderRequest.title}
          text={orderRequest.infoText}
          type={type}
        />
        <div className="flex flex-col items-start pb-12px px-16px mt-12px border-b border-txtlight-shades4">
          <OrderIDAndBookedOn
            orderId={orderRequest.orderId}
            bookedOn={orderRequest.bookedOnDate}
          />
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <PatientName patientName={orderRequest.patientName} />{' '}
          <div className="flex justify-between items-center w-full">
            <DateTimeSlot slotDateTime={orderRequest.slotDateTime} />
            {type === 'orderUpdate' && (
              <div>
                <div className="flex justify-end items-center">
                  <img src={oldTimeIcon} alt="clock" />
                  <p className="text-chip font-medium text-txtsecondary-shades8 ml-2px line-through">
                    {orderRequest.oldTime}
                  </p>
                </div>
                <div className="flex justify-end items-center">
                  <img src={newTimeIcon} alt="clock" />
                  <p className="text-body-l font-medium text-primary ml-4px">
                    {orderRequest.slotDateTime}
                  </p>
                </div>
              </div>
            )}
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <PartnerName partnerName={orderRequest.partnerName} />
            <div className="flex flex-row items-center">
              {type === 'orderUpdateReschedule' && (
                <div>
                  <div className="flex justify-end items-center">
                    <img src={oldTimeIcon} alt="clock" />
                    <p className="text-chip font-medium text-txtsecondary-shades8 ml-2px line-through">
                      {orderRequest.oldTime}
                    </p>
                  </div>
                  <div className="flex justify-end items-center">
                    <img src={newTimeIcon} alt="clock" />
                    <p className="text-body-l font-medium text-primary ml-4px">
                      {orderRequest.slotDateTime}
                    </p>
                  </div>
                </div>
              )}
              {type === 'orderUpdatePartner' && (
                <div className="flex justify-end items-center">
                  <img src={oldPartnerIcon} alt="lab" />
                  <p className="text-body-s font-medium text-txtsecondary-shades8 ml-4px line-through">
                    {orderRequest.oldPartnerName}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div />;
  }
};

PrescriptionStatusCard.propTypes = {
  onTap: PropTypes.func,
  orderRequest: PropTypes.object.isRequired,
};

export default PrescriptionStatusCard;
